// extracted by mini-css-extract-plugin
export var centerText = "_71-8";
export var container = "_71-0";
export var doughnutContainer = "_71-7";
export var legend = "_71-a";
export var legendItemColorDisplay = "_71-b";
export var legendItemLabel = "_71-d";
export var legendItemValue = "_71-c";
export var lg = "_71-5";
export var maxWidth = "_71-9";
export var md = "_71-4";
export var responsive = "_71-6";
export var sm = "_71-3";
export var xs = "_71-2";
export var xxs = "_71-1";